import { Navigate, Route, Routes } from 'react-router-dom';

import * as routing from '../../../constants/Routing';
import { Project } from '../../../domain/project/Project';
import { useRetrieveActiveProject } from '../../../hooks/project/useRetrieveActiveProject';
import { useRetrieveUserCredentials } from '../../../hooks/user/useRetrieveUserCredentials';
import { PlannerStopFields } from './PlannerStopFields';
import { PlannerTaskFields } from './PlannerTaskFields';
import { PlannerVehicleFields } from './PlannerVehicleFields';

interface ProjectSettingsPlannerProps {
  project: Project;
}

export const ProjectSettingsPlanner = ({ project }: ProjectSettingsPlannerProps) => {
  const { data: activeProject } = useRetrieveActiveProject();
  const { data: userCredentials } = useRetrieveUserCredentials();
  return (
    <Routes>
      <Route index element={<Navigate to={routing.PROJECT_SETTINGS.PLANNER.STOPS} />} />
      <Route path="/vehicles" element={<PlannerVehicleFields project={project} />} />
      <Route path="/stops" element={<PlannerStopFields project={project} />} />

      {userCredentials?.subscription.test(`planner.tasks`) && activeProject?.tasks_enabled && (
        <Route path="/tasks" element={<PlannerTaskFields project={activeProject} />} />
      )}

      <Route path="*" element={<Navigate to={routing.PROJECT_SETTINGS.PLANNER.ROOT} />} />
    </Routes>
  );
};
